import React from 'react';
import { Helmet } from 'react-helmet';
import { ROUTES } from '../../lib/constants';
import styles from './AboutUs.module.scss';
import { Button } from '../../components/Button/Button';
import { Image } from '../../components/Image/Image';
import imageM from '../../images/about-us-m.jpg';
import imageD from '../../images/about-us-d.jpg';


export const AboutUs = (): React.JSX.Element => {
  
  return (
    <>
      <Helmet>
        <title>{ROUTES.aboutUs.title}</title>
      </Helmet>

      <section className={styles.hero}>
        <div className={styles.designElement}></div>

        <div className='grid-12'>
          <div className={styles.container}>
            <h1 className='headline__h1-xl color--daylight-blue'>Why choose Cityside Fiber?</h1>
          </div>
        </div>
      </section>

      <section className={styles.main}>
        <div className='grid-12'>
          <div className={styles.container}>
            <div className={styles.content}>
              <div>
                <h2 className='headline__h1'>
                  Cityside Fiber Delivers<br />to Our Communities
                </h2>

                <p>
                  We are Orange County’s premier high-speed internet provider, offering our members the best choice for online connectivity combined with superior concierge-level customer service.
                </p>
              </div>

              <p>
                Based in Irvine, we are committed to connecting communities here in OC with our new fiber-optic network, and our local team is ready to serve you! 
              </p>

              <p>
                We’ve been giving back since we started on day one! Together, as we grow our network and memberships, we’ll continue to give back to our communities through even more sponsorships and donations.
              </p>

              <p>
                Thanks for being a member!
              </p>

              <Button size='lg' path={ROUTES.checkAvailability.path} gradient='orange'>
                Get Started
              </Button>
            </div>

            <div className={styles.imageWrap}>
              <Image 
                sources={[
                  {
                    src: imageM,
                    breakpoint: 'default'
                  },
                  {
                    src: imageD,
                    breakpoint: '960px'
                  }
                ]}
                alt='woman in fron of bakery counter'
              />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}